
import { DateTime } from "luxon";
import CashSessionRequest from "../../libs/core-api-requests/accounting/cashSessionRequest";
import { ICashSessionDTO, ICashSessionStatusKizReportDTO, ICashSessionViewDTO, IChequeKizReportDTO, IChequeReport } from "../../libs/coreapi-dto/accounting/cashSession";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class CashSessionDataProvider extends DictionaryDataProvider<
    ICashSessionViewDTO,
    ICashSessionDTO
> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService){
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<CashSessionRequest> {
        return this._coreApiService.cashSessionRequest;
    }

    closeSession(id: string, body: ICashSessionViewDTO, callback: () => void) { 
        body.documentState = "Closed" 
        body.dateClose = DateTime.now()      
        this.getDataRequest()
            .then(r => r.closeSession(id, body ,() => callback()))
    }

    updateSession(id: string, body: ICashSessionDTO, callback: () => void) {
            this.getDataRequest()
                .then(r => r.updateSession(id, body, (e) => {
                    if (e.respType === 'isCompleted') {
                        try {
                            callback?.();
                        } catch (e) {
                            console.error(e)
                        }
                    }
                    else
                        throw new Error(e?.message.detail ?? 'Update CheckSession !isCompleted');
                }))
        }
    

    getCashSession(body: IViewBody, callback: (entities, totalCount) => void) {
        this.getDataRequest()
            .then(r => r.getCashSession(body, (e) => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data.entities, e.data.totalCount)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.text ?? 'AccountinDataProvider getView !isCompleted');
            }))
    }

    getChequesKizStatus(idGlobal: string, callback: (e: any) => void) {
        this.getDataRequest()
            .then(r => r.getChequesKizStatus(idGlobal, (e) => {
                try {                    
                    callback(e); 
                    if (e.respType !== 'isCompleted') {
                        throw new Error(e?.message?.text ?? 'AccountingDataProvider getView !isCompleted');
                    }
                } catch (error) {
                    console.error('Error in getChequesKizStatus callback:', error);
                }
            }))
            .catch(error => {
                console.error('Error in getChequesKizStatus:', error);                
                callback({ error: true, message: error.message });
            });
    }

    getChequesKizReport(body: ICashSessionStatusKizReportDTO, callback: (idGlobal: string, reports: IChequeReport[]) => void) {
        this.getDataRequest()
            .then(r => r.getChequesKizReport(body, (e) => {
                try {                    
                    callback(e.data.idGlobal, e.data.reports)
                    if (e.respType !== 'isCompleted') {
                        throw new Error(e?.message?.text ?? 'AccountingDataProvider getView !isCompleted');
                    }
                } catch (error) {
                    console.error('Error in getChequesKizReport callback:', error);
                }
            }))
            .catch(error => {
                console.error('Error in getChequesKizReport:', error);
            });
    }

    getSchemeToReport(body: IChequeKizReportDTO, callback: (e) => void) {
        this.getDataRequest()
            .then(r => r.getSchemeToReport(body, (e) => {
                try {                    
                    callback(e); 
                    if (e.respType !== 'isCompleted') {
                        throw new Error(e?.message?.text ?? 'AccountingDataProvider getView !isCompleted');
                    }
                } catch (error) {
                    console.error('Error in getSchemeToReport callback:', error);
                }
            }))
            .catch(error => {
                console.error('Error in getSchemeToReport:', error);                
                callback({ error: true, message: error.message });
            });
    }

    getSumParameters(idGlobal: string, callback: (e: any) => void) {
        this.getDataRequest()
            .then(r => r.getSumParameters(idGlobal, (e) => {
                try {                    
                    callback(e); 
                    if (e.respType !== 'isCompleted') {
                        throw new Error(e?.message?.text ?? 'CashSessionDataProvider getSumParameters !isCompleted');
                    }
                } catch (error) {
                    console.error('Error in getSumParameters callback:', error);
                }
            }))
            .catch(error => {
                console.error('Error in getSumParameters:', error);                
                callback({ error: true, message: error.message });
            });
    }
}